import React, { useState, useEffect } from 'react';
import { useCompany } from '../contexts/CompanyContext';
import { useHistory } from 'react-router-dom';
import Cookies from 'js-cookie';
import { UpdateSelector } from '../contexts/calendar/UpdateCalendarSelect.context';
import { ModalCalendarContext, OptionsModalConfig } from '../contexts/calendar/ModalCalendarContext.context';
import { ModalConfigurationContext, Options as ConfigOptions } from '../contexts/calendar/ModalConfigurationContext.context';
import { CalendarsContext } from '../contexts/calendar/CalendarsContext.context';
import { CalendarContext, SelectedCalendar } from '../contexts/calendar/CalendarContext.context';
import { Calendar } from '../models/calendar/Calendar.model';

/**
 * Provides all calendar-module specific contexts.
 * Wrap any component tree that needs access to calendar, calendars,
 * updater, modal-calendar, or modal-configuration state.
 */
export default function CalendarProviders({ children }: { children: React.ReactNode }) {
  const [updater, setUpdater] = useState<boolean>(false);
  const [calendars, setCalendars] = useState<Calendar[]>([]);
  const [calendar, setCalendar] = useState<SelectedCalendar>({ id: '', uid: '', color: '', availableWeekRules: [], weekAvailable: [] });
  const [optionsModal, setOptionsModal] = useState<OptionsModalConfig>({
    id: '', isopen: false, isEditing: false, isConfiguration: false, isCreating: false, width: '520px'
  });
  const [optionsConfig, setOptionsConfig] = useState<ConfigOptions>({
    id: '', isopen: false, isConfigUser: false, width: '520px'
  });

  const { company } = useCompany();
  const history = useHistory();

  useEffect(() => {
    if (company?.current?.uid) {
      setCalendar({ id: '', uid: '', color: '', availableWeekRules: [], weekAvailable: [] });
      setCalendars([]);
      Cookies.remove('calendar_id', { path: '/' });
      if (history.location.pathname !== '/calendar') {
        history.push('/calendar');
      }
    }
  }, [company?.current?.uid, history]);

  return (
    <UpdateSelector.Provider value={{ updater, setUpdater }}>
      <CalendarsContext.Provider value={{ calendars, setCalendars }}>
        <CalendarContext.Provider value={{ calendar, setCalendar }}>
          <ModalCalendarContext.Provider value={{ options: optionsModal, setOptions: setOptionsModal }}>
            <ModalConfigurationContext.Provider value={{ options: optionsConfig, setOptions: setOptionsConfig }}>
              {children}
            </ModalConfigurationContext.Provider>
          </ModalCalendarContext.Provider>
        </CalendarContext.Provider>
      </CalendarsContext.Provider>
    </UpdateSelector.Provider>
  );
}
